/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as AppStaffRouteImport } from './routes/_app/staff'
import { Route as AppServicesRouteImport } from './routes/_app/services'
import { Route as AppSalesRouteImport } from './routes/_app/sales'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppClientsRouteImport } from './routes/_app/clients'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppStaffRoute = AppStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppServicesRoute = AppServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/clients': typeof AppClientsRoute
  '/products': typeof AppProductsRoute
  '/sales': typeof AppSalesRoute
  '/services': typeof AppServicesRoute
  '/staff': typeof AppStaffRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesByTo {
  '/clients': typeof AppClientsRoute
  '/products': typeof AppProductsRoute
  '/sales': typeof AppSalesRoute
  '/services': typeof AppServicesRoute
  '/staff': typeof AppStaffRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/clients': typeof AppClientsRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/sales': typeof AppSalesRoute
  '/_app/services': typeof AppServicesRoute
  '/_app/staff': typeof AppStaffRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clients'
    | '/products'
    | '/sales'
    | '/services'
    | '/staff'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clients'
    | '/products'
    | '/sales'
    | '/services'
    | '/staff'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/'
  id:
    | '__root__'
    | '/_app'
    | '/_app/clients'
    | '/_app/products'
    | '/_app/sales'
    | '/_app/services'
    | '/_app/staff'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpSplatRoute: typeof SignUpSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/sign-up/$': {
      id: '/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof SignUpSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/staff': {
      id: '/_app/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/services': {
      id: '/_app/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AppServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales': {
      id: '/_app/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppClientsRoute: typeof AppClientsRoute
  AppProductsRoute: typeof AppProductsRoute
  AppSalesRoute: typeof AppSalesRoute
  AppServicesRoute: typeof AppServicesRoute
  AppStaffRoute: typeof AppStaffRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppClientsRoute: AppClientsRoute,
  AppProductsRoute: AppProductsRoute,
  AppSalesRoute: AppSalesRoute,
  AppServicesRoute: AppServicesRoute,
  AppStaffRoute: AppStaffRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
